import React, { useState } from "react"
import { injectIntl } from "react-intl"
import { withRouter } from "react-router-dom"
import Checkbox from "../../checkbox/checkbox.component.jsx"
import Icon from "../../icon/icon.component"
import FeatureProtectionWrapperMain from "./featureProtectionWrapperMain.component"
import { handleClick } from "./helpers.jsx"
import { Intl } from "../../../state/helpers/IntlProps"

type OwnProps = {
    isProtected: boolean
    protectionRule: boolean
    disabled: boolean
    protectedClassName: string
    accountFeatureKey: string
    className: string
    type: "button" | "submit" | "reset"
    children: JSX.Element
    showLock: boolean
    premium: boolean
    index: number
    message: string
    checked: boolean
    callback: () => void
    onClose: () => void
    onClickProtected: () => void
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
    intl: Intl
}

const CheckboxWrapper = (props: OwnProps) => {
    const [displayModal, setDisplayModal] = useState(false)
    const showLock = props.showLock ?? true

    const lockedItem = <button key={"checkbox-wrapper" + props.index} className={props.protectedClassName || "btn"}
        onClick={(e) => { handleClick(e, props, setDisplayModal) }} disabled={props.disabled} type={props.type}>
        {props.children} {showLock && <Icon value="lock" className="lock" />}
    </button>

    const item = <Checkbox checked={props.checked} onChange={props.onClick} />
    return (<>
        <FeatureProtectionWrapperMain
            protectionRule={props.protectionRule}
            accountFeatureKey={props.accountFeatureKey}
            isProtected={props.isProtected ?? true}
            displayModal={displayModal}
            premium={props.premium}
            lockedItem={lockedItem}
            message={props.message}
            item={item}
            callback={props.callback || function () { return }}
            onClickProtected={props.onClickProtected || function () { return }}
            onClose={() => {
                setDisplayModal(false)
                if (props.onClose) {
                    props.onClose()
                }
            }}
            onClick={props.onClick || function () { return }}
        >

        </FeatureProtectionWrapperMain>
    </>)


}

export default withRouter(injectIntl(CheckboxWrapper))


// WEBPACK FOOTER //
// ./src/common/rich-text/feature-protection-wrappers/checkboxWrapper.component.tsx